export default "__VITE_ASSET__8f8f8756__"